import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {CurrencyConfiguration} from "@next/utils"
import connect from "./connect"

export interface FacetsPriceSelectorProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    name: string
    isTabbedFilter?: boolean
    globalPriceFormattingConfig: CurrencyConfiguration
}

export const FacetsPriceSelector = memo(
    ({templating, name, isTabbedFilter, globalPriceFormattingConfig}: FacetsPriceSelectorProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)

        return (
            <Suspense>
                <ComponentName
                    name={name}
                    isTabbedFilter={isTabbedFilter}
                    globalPriceFormattingConfig={globalPriceFormattingConfig}
                />
            </Suspense>
        )
    },
)
FacetsPriceSelector.displayName = "FacetsPriceSelector"
export default connect(FacetsPriceSelector)
